export class WorldAssignmentGlobals {
    public isTestEnvironment: boolean;
    public forceToShowTestServers: boolean;
    public useDynamicWorldAssignment: boolean;
    public geoIPUrl: string = "http://i2c.goodgamestudios.com";
    public countriesConfigUrl: string;
    public networkConfigUrl: string;
    public branchesConfigUrl: string;
    public versionUrl: string;
    public zoneCapacityUrl: string;
    public browserLanguage: string;
    public timezoneOffset: number;
    public countryCodeFromNetworkCookie: string; //BasicModel.networkCookie.country
    public countryCodeFromQueryString: string; //env.urlVariables.country
    public isHydraLogin: boolean; // has env.urlVariables.suk  ( it means that logins is happening via Hydra - Customer Support)
    public fakeGeoIpResponse: string;
    public alsoDetectUnavailableCountries: boolean;
    public presetInstanceId: number;
    public instanceIdFromNetworkCookie: number;
    public zoneIdFromNetworkCookie: number;
    public zoneIdFromFriendInviteCode: number;
    public countryCodeFromFriendInviteCode: string;
}
